import axios from "axios";
import { getBackendUrl } from "../utils/env";

export const getMenuSettings = async () => {
    const { data } = await axios.get(`${getBackendUrl()}api/menu.php`);
    return data.data;
};